var map = {
	"./404.svg": "vqtR",
	"./admin.svg": "2VL8",
	"./bug.svg": "ILiG",
	"./chart.svg": "Adp7",
	"./clipboard.svg": "E/rC",
	"./comment.svg": "/6/+",
	"./component.svg": "iX2x",
	"./create-user.svg": "KX90",
	"./dashboard.svg": "g1C8",
	"./documentation.svg": "3z6i",
	"./dollar.svg": "DfEh",
	"./drag.svg": "z8XX",
	"./edit.svg": "Q5vV",
	"./education.svg": "CGWP",
	"./email.svg": "9t2C",
	"./example.svg": "pq69",
	"./excel.svg": "0tFp",
	"./exit-fullscreen.svg": "U0Hw",
	"./eye-open.svg": "iY8V",
	"./eye.svg": "H2+w",
	"./form.svg": "Voym",
	"./fullscreen.svg": "nNaA",
	"./guide 2.svg": "KSZQ",
	"./guide.svg": "TyQB",
	"./icon.svg": "b/7G",
	"./international.svg": "itC+",
	"./language.svg": "73mK",
	"./layout.svg": "CojG",
	"./like.svg": "81iY",
	"./link.svg": "/PVJ",
	"./list.svg": "VGMA",
	"./lock.svg": "o8Ke",
	"./message.svg": "w7kc",
	"./money.svg": "Iv/V",
	"./nested.svg": "AwmV",
	"./password.svg": "qe9Z",
	"./pdf.svg": "7Ojz",
	"./people.svg": "nvwE",
	"./peoples.svg": "SQHB",
	"./qq.svg": "1mKp",
	"./role.svg": "wPM4",
	"./search.svg": "ZxKU",
	"./shopping.svg": "PRSx",
	"./size.svg": "WOdR",
	"./skill.svg": "VMQ+",
	"./star.svg": "umjs",
	"./tab.svg": "1Ow3",
	"./table.svg": "Ynnx",
	"./theme.svg": "9jgq",
	"./tree-table.svg": "C6S3",
	"./tree.svg": "Oumj",
	"./user.svg": "0OSj",
	"./wechat.svg": "U8C0",
	"./zip.svg": "FcHx"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Olrp";